import { render, staticRenderFns } from "./user-passwd.vue?vue&type=template&id=6eaf5cc0&"
import script from "./user-passwd.vue?vue&type=script&lang=js&"
export * from "./user-passwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "user-passwd.vue"
export default component.exports